"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import Link from "next/link";
import type { CampaignPageSection } from "@growwithai/shared";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type CountdownProps = Extract<CampaignPageSection, {
  type: "countdown";
}>;
function diff(target: number) {
  const ms = Math.max(0, target - Date.now());
  const s = Math.floor(ms / 1000);
  return {
    expired: ms === 0,
    days: Math.floor(s / 86400),
    hours: Math.floor(s % 86400 / 3600),
    minutes: Math.floor(s % 3600 / 60),
    seconds: s % 60
  };
}

/** Hitung mundur live ke target_at (dihitung di client, hindari mismatch SSR). */
export default function CountdownSection(t0) {
  const $ = _c(44);
  const {
    section
  } = t0;
  let t1;
  if ($[0] !== section.target_at) {
    t1 = new Date(section.target_at).getTime();
    $[0] = section.target_at;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const target = t1;
  let t2;
  if ($[2] !== target) {
    t2 = () => diff(target);
    $[2] = target;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [t, setT] = useState(t2);
  let t3;
  let t4;
  if ($[4] !== target) {
    t3 = () => {
      const id = setInterval(() => setT(diff(target)), 1000);
      return () => clearInterval(id);
    };
    t4 = [target];
    $[4] = target;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== t.days) {
    t5 = {
      label: "Hari",
      value: t.days
    };
    $[7] = t.days;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t.hours) {
    t6 = {
      label: "Jam",
      value: t.hours
    };
    $[9] = t.hours;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t.minutes) {
    t7 = {
      label: "Menit",
      value: t.minutes
    };
    $[11] = t.minutes;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t.seconds) {
    t8 = {
      label: "Detik",
      value: t.seconds
    };
    $[13] = t.seconds;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t6 || $[17] !== t7 || $[18] !== t8) {
    t9 = [t5, t6, t7, t8];
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const units = t9;
  let t10;
  if ($[20] !== section.custom_style) {
    t10 = sectionBgStyle(section.custom_style);
    $[20] = section.custom_style;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== section.custom_style) {
    t11 = sectionHeadingStyle(section.custom_style);
    $[22] = section.custom_style;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== section.heading || $[25] !== t11) {
    t12 = <h2 className="text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t11}>{section.heading}</h2>;
    $[24] = section.heading;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== section.subheading) {
    t13 = section.subheading && <p className="mx-auto mt-2 max-w-xl text-sm text-warm-black/70">{section.subheading}</p>;
    $[27] = section.subheading;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== section.expired_message || $[30] !== t.expired || $[31] !== units) {
    t14 = t.expired ? <p className="mt-8 text-lg font-semibold text-[var(--brand-primary)]">{section.expired_message}</p> : <div className="mt-8 flex items-stretch justify-center gap-1.5 sm:gap-2.5 md:gap-4">{units.map(_temp)}</div>;
    $[29] = section.expired_message;
    $[30] = t.expired;
    $[31] = units;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== section.cta || $[34] !== t.expired) {
    t15 = section.cta && !t.expired && <div className="mt-8"><Link href={section.cta.href} className="inline-flex items-center rounded-xl bg-[var(--brand-primary)] px-6 py-3 text-sm font-semibold text-[var(--brand-on-primary,#fff)] shadow-sm transition hover:opacity-90">{section.cta.label}</Link></div>;
    $[33] = section.cta;
    $[34] = t.expired;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t12 || $[37] !== t13 || $[38] !== t14 || $[39] !== t15) {
    t16 = <div className="mx-auto max-w-3xl px-5 text-center">{t12}{t13}{t14}{t15}</div>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t10 || $[42] !== t16) {
    t17 = <section className="bg-warm-cream py-14 md:py-20" style={t10}>{t16}</section>;
    $[41] = t10;
    $[42] = t16;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
}
function _temp(u) {
  return <div key={u.label} className="min-w-[56px] rounded-2xl bg-white px-3 py-4 shadow-sm sm:min-w-[64px] md:min-w-[84px]"><div className="text-3xl font-black tabular-nums text-[var(--brand-primary)] md:text-4xl">{String(u.value).padStart(2, "0")}</div><div className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-warm-black/50">{u.label}</div></div>;
}